import React, { Component } from 'react';
import logo from '../../images/logoFlat.svg';
import logoUfjf from '../../images/logoUfjf.png';
import Spinner from '../components/spinner';
import FacebookLogin from '../../utils/facebookLogin';

// import GoogleLogin from '../../utils/googleLogin';

class Login extends Component {
    constructor () {
        super();
        this.state = {
            askEmail: false,
            login: null,
            input: null
        };
    }

    render () {
        window.addEventListener('beforeinstallprompt', function (e) {
            // beforeinstallprompt Event fired
            // e.userChoice will return a Promise.
            e.userChoice.then(function (choiceResult) {
                console.log(choiceResult.outcome);
                if (choiceResult.outcome === 'dismissed') {
                    console.log('User cancelled home screen install');
                } else {
                    console.log('User added to home screen');
                }
            });
        });

        const {email, password} = this.props.input;

        if (this.props.loading) {
            return (
                <div className='auth-background loginView flex'>
                    <Spinner />
                </div>
            );
        }
        if (!this.state.askEmail) {
            return (
                <div className='auth-background loginView'>
                    <div className='auth-logo-wrapper'>
                        <img className='auth-logo' src={logo} alt='logo' />
                    </div>
                    <br />
                    <br />
                    <br />
                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        <div className='input-field-wrapper'>
                            {/* <img src={inputText} className='input-field-background' /> */}
                            {/* <div className='input-field-inner-wrapper'> */}
                            <input type='email' name='email' placeholder='Email' className='input-field'
                                value={this.props.input.email}
                                onChange={(e) => this.props.inputChanged('email', e.target.value)} />
                            {/* </div> */}
                        </div>

                        <ErrorRenderer condition={this.props.emailError !== null}
                            message={this.props.emailError} />

                        <div className='input-field-wrapper'>
                            {/* <img src={inputText} className='input-field-background' /> */}
                            {/* <div className='input-field-inner-wrapper'> */}
                            <input type='password' placeholder='Senha' className='input-field'
                                value={this.props.input.password}
                                onChange={(e) => this.props.inputChanged('password', e.target.value)} />
                            {/* </div> */}
                        </div>
                    </div>
                    <ErrorRenderer
                        condition={this.props.passwordError}
                        message={this.props.passwordError} />
                    <ErrorRenderer
                        condition={this.props.error}
                        message={this.props.error} />
                    <div className='container-buttons'>
                        <div className='btn block login'
                            onClick={() => this.props.loginUser({email, password})}>
                            <h4>Entrar</h4>
                        </div>
                    </div>
                    <div className='container-buttons'>
                        <div className='btn block facebook login'
                            onClick={() => FacebookLogin.checkStatusAndLogin().then((response) => {
                                if (!response.email) {
                                    this.setState({askEmail: true, input: response, login: 'facebook'});
                                } else {
                                    this.props.loginUserFacebook(response);
                                }
                            })}>
                            <h4>Entrar com Facebook</h4>
                        </div>
                    </div>
                    {/*
                <div className='container-buttons'>
                    <div className='btn block google login'
                        onClick={() => GoogleLogin.checkStatusAndLogin().then((response) => {
                            console.log('GOOGLESTATUS', response);
                        })}>
                        <h4>Entrar com Google</h4>
                    </div>
                </div>
                */}
                    <div className='login-container-buttons'>
                        <div onClick={() => this.props.history.push('resetpassword')}>Senha</div>
                        <div>|</div>
                        <div onClick={() => this.props.history.push('signup')}>Registro</div>
                    </div>
                    <div className='logo-ufjf'>
                        <img src={logoUfjf} />
                    </div>
                </div>
            );
        } else {
            return (
                <div className='auth-background loginView'>
                    <div className='auth-logo-wrapper'>
                        <img className='auth-logo' src={logo} alt='logo' />
                    </div>
                    <br />
                    <br />
                    <br />
                    <div className='userdata-info'>
                        Preencha seu email para poder entrar.
                    </div>
                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        <div className='input-field-wrapper'>
                            <input type='email' name='email' placeholder='Email' className='input-field'
                                value={this.props.input.email}
                                onChange={(e) => this.props.inputChanged('email', e.target.value)} />
                        </div>
                    </div>
                    <div className='container-buttons'>
                        <div className='btn block login'
                            onClick={() => {
                                let {input} = this.state;
                                input.email = this.props.input.email;
                                if (this.state.login === 'facebook') {
                                    this.props.loginUserFacebook(input);
                                }
                            }}>
                            <h4>Entrar</h4>
                        </div>
                    </div>
                    <div className='login-container-buttons'>
                        <div onClick={() => this.props.history.push('resetpassword')}>Senha</div>
                        <div>|</div>
                        <div onClick={() => this.props.history.push('signup')}>Registro</div>
                    </div>
                    <div className='logo-ufjf'>
                        <img src={logoUfjf} />
                    </div>
                </div>
            );
        }
    }
}

const ErrorRenderer = (props) => (
    <div className='auth-error-container'>
        <div className='auth-error-wrapper'>
            {
                props.condition
                    ? <span className='auth-error-message'>{props.message}</span>
                    : null
            }
        </div>
    </div>
);

export default Login;



// WEBPACK FOOTER //
// ./src/views/AuthViews/loginView.js